<template>
    <div class="login-page" style="margin-top: 400px">
        <LoginForm />
    </div>
</template>

<script>
    import LoginForm from "../components/forms/LoginForm";
    export default {
        name: "LogIn",
        components: {LoginForm}
    }
</script>

<style scoped>

</style>
